/**

 Vuex state store
 Main js file for defining the Vuex store for the state for Cortex,
 used to collect and export all of the actions, mutations and modules
 as a single store for access across the app

 **/
import Vue from 'vue';
import Vuex from 'vuex';
import analyticsModule from './modules/analyticsModule';
import clientModule from './modules/clientModule';
import editorModule from './modules/editorModule.js';
import exportsModule from './modules/exportsModule.js';
import fileModule from './modules/fileModule';
import languageModule from './modules/languageModule';
import libraryModule from './modules/libraryModule';
import mapModule from './modules/mapModule';
import routesModule from './modules/routesModule';
import timezoneModule from './modules/timezoneModule';
import topicsModule from './modules/topicsModule';
import toursModule from './modules/toursModule';
import triggersModule from './modules/triggersModule';
import userModule from './modules/userModule';
import releaseModule from './modules/releaseModule';

Vue.use(Vuex);

export default new Vuex.Store({
  namespace: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    analytics: analyticsModule,
    client: clientModule,
    editor: editorModule,
    exports: exportsModule,
    file: fileModule,
    language: languageModule,
    library: libraryModule,
    map: mapModule,
    routes: routesModule,
    timezone: timezoneModule,
    topics: topicsModule,
    tours: toursModule,
    triggers: triggersModule,
    user: userModule,
    release: releaseModule
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js